import { useSnackbar } from 'notistack';
import { useCallback } from 'react';

export const useErrorSnackbar = () => {
  const { enqueueSnackbar } = useSnackbar();

  const showError = useCallback((msg) => {
    enqueueSnackbar && enqueueSnackbar(msg || 'error', { variant: 'error' });
  }, [enqueueSnackbar]);

  return showError;
};

